export default "__VITE_ASSET__64adcee9__"